/* import __COLOCATED_TEMPLATE__ from './diy-project-analytics.hbs'; */
import EmberObject, { computed } from '@ember/object';
import DiyBaseAnalytics from './diy-base-analytics';
import ICON_PATH from '../../../constants/assets/icons';

// parameters
const COST_CODE = 'costCode';
const COST = 'totalInvoice';
const MONTH = 'MONTH';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

const COST_CODE_LABELS = [
  'Social Media',
  'Brand Creative - US',
  'Brand Creative - Global'
];

const NUMBER_OF_PROJECTS = 150;
const MIN_COST = 1250;
const MAX_COST = 9000;

export default DiyBaseAnalytics.extend({
  classNames: ['diy-project-analytics'],
  title: 'Track Your projects',
  text: 'Stay on top of things. Get detailed insights into your project spend, duration, activity and more by upgrading to a subscription plan.',
  icon: ICON_PATH.PROJECT_REPORT,

  init() {
    this._super(...arguments);
    const projects = [];
    for (let i = 0; i < NUMBER_OF_PROJECTS; i++) {
      projects.push(EmberObject.create({
        MONTH: Math.floor(Math.random() * 12),
        totalInvoice: Math.random() * (MAX_COST - MIN_COST) + MIN_COST,
        costCode: COST_CODE_LABELS[Math.floor(Math.random() * COST_CODE_LABELS.length)],
      }));
    }

    this.set('data', projects);
  },
  ///////////
  // CHART //
  ///////////
  chartKeyParam: MONTH,
  sumParam: COST,
  groupParam: COST_CODE,

  chartLabels: computed(function() {
    const labels = {};
    for (let month = 0; month < 12; month++) {
      labels[month] = MONTHS[month];
    }

    return labels;
  }),

  chartSumFormatter: computed('sumParam', function() {
    const sumParam = this.get('sumParam');
    switch (sumParam) {
      case COST:
        return this.formatMoneyWithoutChange.bind(this);
      default:
        return null;
    }
  }),
});
